<template>
  <div class="import-data-result-content">
    <el-container>
      <el-main>
        <el-row  class="import-data-result">
          <div class="current-customer">
            <p>当前客户数量:{{totalCustomer}}</p>
          </div>
          <div class="import-total-content">
            <p>导入</p>
            <div class="line"></div>
            <div class="total-result">
             <!--  <p>表中共有1条客户数据， --><b style="color: green;">{{importCustomer}}</b>条导入成功
              <!-- <b style="color: red;">0</b>条导入失败。 --><!-- </p> -->
              <el-progress :percentage="100" status="success"></el-progress>
            </div>
            <p>注:您可关闭当前页面不影响后台数据导入</p>
            <el-button  type="primary" size="small" style="float: right; margin-right: 30px;" @click="nextStep">进行下一次导入</el-button>
          </div>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { } from '@/api/customer.js'

export default {
  name: 'importData',
  data () {
    return {
      totalCustomer: 0,
      importCustomer: 0
    }
  },
  methods: {
    nextStep() {
      router.push('/home/import-data')
    }
  },
  created() {
    this.totalCustomer = this.$route.query.total_customer
    this.importCustomer = this.$route.query.import_customer
  },
  components: {
  }
}
</script>

<style scoped>
.current-customer {
  background-color: #fff;
  height: 60px;
  padding: 20px 20px;
}
.current-customer p {
  text-align: left;
}
.import-total-content {
  margin-top: 10px;
  background-color: #fff;
  height: 280px;
  padding: 10px;
}
.import-total-content p {
  margin-top: 0px;
}
.import-total-content {
  text-align: left;
}
.line {
  width: 100%;
  height: 1px;
  background: #dedede;
}
.total-result {
  padding: 10px;
  width: 80%;
  height: 90px;
  margin: 10px auto;
}

</style>
